module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 80);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/variable");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/bridge");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/component");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/button");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/user");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/api");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = require("@tencent/iwan-atta-fe");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/helper");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/select");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/radio-group");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ zone_role_select_ZoneRoleSelect; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/slicedToArray"
var slicedToArray_ = __webpack_require__(17);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(2);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(7);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(5);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(8);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(6);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(9);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(0);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@tencent/txv-utils"
var txv_utils_ = __webpack_require__(1);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/component"
var component_ = __webpack_require__(12);
var component_default = /*#__PURE__*/__webpack_require__.n(component_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/variable"
var variable_ = __webpack_require__(10);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/helper"
var helper_ = __webpack_require__(3);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/bridge"
var bridge_ = __webpack_require__(11);
var bridge_default = /*#__PURE__*/__webpack_require__.n(bridge_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/user"
var user_ = __webpack_require__(20);
var user_default = /*#__PURE__*/__webpack_require__.n(user_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/api"
var api_ = __webpack_require__(21);
var api_default = /*#__PURE__*/__webpack_require__.n(api_);

// CONCATENATED MODULE: ./src/core/zone/index.js



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var zone = {
  gameZoneCache: {},
  // 游戏区服缓存
  userPlayZoneCache: {},
  // 历史区服
  /**
   * 默认获取游戏区服后台接口
   * @param opts
   * opts.params 给到接口参数
   * opts.cgiGameZone为业务自定义获取数据方式，需返回数据格式化成与默认接口相同格式
   * @returns {Promise<*>}
   * {errno:0, message: "success", data:{gameType, hasRole, list: [], md5, total}}
   */
  submitGameZone: function submitGameZone(opts) {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var cgiGameZone, data;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cgiGameZone = opts.cgiGameZone, data = opts.data;
            if (!Object(txv_utils_["isFunction"])(cgiGameZone)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", cgiGameZone.bind(_this)({
              params: data
            }));
          case 3:
            return _context.abrupt("return", api_default.a.get('/zone/getGameZone', {
              params: data
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * 默认获取用户被记录过的区服id
   * @param opts
   * opts.params  给到接口参数
   * opts.cgiUserGameZone为业务自定义获取数据方式，需返回数据格式化成与默认接口相同格式
   * @returns {Promise<*>}
   * {code:100000, msg: "ok", data: [{main_district_id: "1"},{main_district_id: "2"}]}
   */
  submitUserGameZone: function submitUserGameZone(opts) {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var cgiUserGameZone, data;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            cgiUserGameZone = opts.cgiUserGameZone, data = opts.data;
            if (!Object(txv_utils_["isFunction"])(cgiUserGameZone)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", cgiUserGameZone.bind(_this2)({
              params: data
            }));
          case 3:
            return _context2.abrupt("return", api_default.a.get('/api/v6/getUserPlayGameZone', {
              params: data
            }));
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /**
   * 校验 data 中的字段是否都合法
   * @param {Object} data
   * @returns {Boolean}
   */
  checkField: function checkField(data) {
    var keys = Object.keys(data);
    var rel = keys.every(function (key) {
      return data[key];
    });
    return rel;
  },
  getGameZone: function getGameZone() {
    var _arguments = arguments,
      _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var opts, zoneCache, res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            opts = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
            zoneCache = _this3.findGameZone(opts);
            if (!zoneCache) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return", zoneCache);
          case 4:
            _context3.next = 6;
            return _this3.updateGameZoneCache(opts);
          case 6:
            res = _this3.findGameZone(opts);
            return _context3.abrupt("return", res);
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  findGameZone: function findGameZone() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _opts$data = opts.data,
      data = _opts$data === void 0 ? {} : _opts$data;
    var gameId = data.gameId,
      system = data.system,
      channel = data.channel;
    var check = this.checkField({
      gameId: gameId,
      system: system,
      channel: channel
    });
    if (!check) {
      console.warn("\u8B66\u544A\uFF1A\u7F3A\u5C11\u53C2\u6570\u3002gameId:".concat(gameId, " system:").concat(system, " channel:").concat(channel));
      return;
    }
    var gameZoneCache = _objectSpread(defineProperty_default()({}, gameId, defineProperty_default()({}, system, {})), this.gameZoneCache);
    var cache = gameZoneCache[gameId][system][channel];
    return cache;
  },
  updateGameZoneCache: function updateGameZoneCache(opts) {
    var _this4 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var _opts$data2, data, gameId, system, channel, _yield$to, _yield$to2, err, res;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _opts$data2 = opts.data, data = _opts$data2 === void 0 ? {} : _opts$data2;
            gameId = data.gameId, system = data.system, channel = data.channel;
            _context4.next = 4;
            return Object(txv_utils_["to"])(_this4.submitGameZone(opts));
          case 4:
            _yield$to = _context4.sent;
            _yield$to2 = slicedToArray_default()(_yield$to, 2);
            err = _yield$to2[0];
            res = _yield$to2[1];
            if (!err && !res.errno) {
              _this4.gameZoneCache[gameId] = defineProperty_default()({}, system, defineProperty_default()({}, channel, [null, res]));
            }
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  getUserPlayZone: function getUserPlayZone() {
    var _arguments2 = arguments,
      _this5 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var opts, userPlayZone, res;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            opts = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
            _context5.next = 3;
            return _this5.findUserPlayZone(opts);
          case 3:
            userPlayZone = _context5.sent;
            if (!userPlayZone) {
              _context5.next = 6;
              break;
            }
            return _context5.abrupt("return", userPlayZone);
          case 6:
            _context5.next = 8;
            return _this5.updateUserPlayZoneCache(opts);
          case 8:
            _context5.next = 10;
            return _this5.findUserPlayZone(opts);
          case 10:
            res = _context5.sent;
            return _context5.abrupt("return", res);
          case 12:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  findUserPlayZone: function findUserPlayZone() {
    var _arguments3 = arguments,
      _this6 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var opts, _opts$data3, data, gameId, system, userKey, check, userPlayZoneCache, cache;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            opts = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {};
            _opts$data3 = opts.data, data = _opts$data3 === void 0 ? {} : _opts$data3;
            gameId = data.gameId, system = data.system;
            _context6.next = 5;
            return user_default.a.userKey();
          case 5:
            userKey = _context6.sent;
            check = _this6.checkField({
              gameId: gameId,
              system: system,
              userKey: userKey
            });
            if (check) {
              _context6.next = 10;
              break;
            }
            console.warn("\u8B66\u544A\uFF1A\u7F3A\u5C11\u53C2\u6570\u3002gameId:".concat(gameId, " system:").concat(system));
            return _context6.abrupt("return");
          case 10:
            userPlayZoneCache = _objectSpread(defineProperty_default()({}, gameId, defineProperty_default()({}, system, {})), _this6.userPlayZoneCache);
            cache = userPlayZoneCache[gameId][system][userKey];
            return _context6.abrupt("return", cache);
          case 13:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  updateUserPlayZoneCache: function updateUserPlayZoneCache(opts) {
    var _this7 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      var _opts$data4, data, gameId, system, userKey, _yield$to3, _yield$to4, err, res;
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _opts$data4 = opts.data, data = _opts$data4 === void 0 ? {} : _opts$data4;
            gameId = data.gameId, system = data.system;
            _context7.next = 4;
            return user_default.a.userKey();
          case 4:
            userKey = _context7.sent;
            _context7.next = 7;
            return Object(txv_utils_["to"])(_this7.submitUserGameZone(opts));
          case 7:
            _yield$to3 = _context7.sent;
            _yield$to4 = slicedToArray_default()(_yield$to3, 2);
            err = _yield$to4[0];
            res = _yield$to4[1];
            if (!err && variable_["CODES_SUCCESS"].codes.includes(res.code)) {
              _this7.userPlayZoneCache[gameId] = defineProperty_default()({}, system, defineProperty_default()({}, userKey, res));
            }
            return _context7.abrupt("return", res);
          case 13:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  /**
   * localstorage获取区服数据
   * @param opts
   */
  getZoneLocalStorage: function getZoneLocalStorage() {
    var _arguments4 = arguments;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      var opts, prefix, _opts$data5, data, gameId, system, channel, key, zoneStorage, res, storageCache, gameZoneRes;
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            opts = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {};
            prefix = opts.prefix, _opts$data5 = opts.data, data = _opts$data5 === void 0 ? {} : _opts$data5;
            gameId = data.gameId, system = data.system, channel = data.channel;
            if (prefix) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return");
          case 5:
            key = "".concat(prefix, "_zone_").concat(gameId);
            _context8.next = 8;
            return bridge_default.a.getNativeStorage(key);
          case 8:
            zoneStorage = _context8.sent;
            res = zoneStorage || {};
            storageCache = _objectSpread(defineProperty_default()({}, system, {}), res);
            gameZoneRes = storageCache[system][channel];
            return _context8.abrupt("return", gameZoneRes);
          case 13:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  },
  /**
   * localstorage设置区服数据
   * @param opts
   */
  setZoneLocalStorage: function setZoneLocalStorage() {
    var _arguments5 = arguments,
      _this8 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      var opts, prefix, _opts$data6, data, _opts$res, res, gameId, system, channel, check, key, zoneStorage, result, storageCache;
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            opts = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {};
            prefix = opts.prefix, _opts$data6 = opts.data, data = _opts$data6 === void 0 ? {} : _opts$data6, _opts$res = opts.res, res = _opts$res === void 0 ? {} : _opts$res;
            gameId = data.gameId, system = data.system, channel = data.channel;
            check = _this8.checkField({
              prefix: prefix,
              gameId: gameId,
              system: system,
              channel: channel
            });
            if (check) {
              _context9.next = 6;
              break;
            }
            return _context9.abrupt("return");
          case 6:
            // 更新localstorage
            key = "".concat(prefix, "_zone_").concat(gameId);
            _context9.next = 9;
            return bridge_default.a.getNativeStorage(key);
          case 9:
            zoneStorage = _context9.sent;
            result = zoneStorage || {};
            storageCache = _objectSpread(defineProperty_default()({}, system, {}), result);
            storageCache[system][channel] = res;
            storageCache[system][channel].time = Date.now();
            bridge_default.a.setNativeStorage(key, storageCache);
          case 15:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  /**
   * localstorage获取用户玩过的区服数据
   * @param opts
   */
  getPlayZoneLocalStorage: function getPlayZoneLocalStorage() {
    var _arguments6 = arguments,
      _this9 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      var opts, _opts$data7, data, prefix, gameId, system, userKey, check, key, zoneHistoryStorage, result, storageCache;
      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            opts = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : {};
            _opts$data7 = opts.data, data = _opts$data7 === void 0 ? {} : _opts$data7, prefix = opts.prefix;
            gameId = data.gameId, system = data.system;
            _context10.next = 5;
            return user_default.a.userKey();
          case 5:
            userKey = _context10.sent;
            check = _this9.checkField({
              prefix: prefix,
              userKey: userKey
            });
            if (check) {
              _context10.next = 9;
              break;
            }
            return _context10.abrupt("return");
          case 9:
            key = "".concat(prefix, "_zone_user_history_").concat(gameId);
            _context10.next = 12;
            return bridge_default.a.getNativeStorage(key);
          case 12:
            zoneHistoryStorage = _context10.sent;
            result = zoneHistoryStorage || {};
            storageCache = _objectSpread(defineProperty_default()({}, system, {}), result);
            return _context10.abrupt("return", storageCache[system][userKey]);
          case 16:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }))();
  },
  /**
   * localstorage设置用户玩过的区服数据
   * @param opts
   */
  setPlayZoneLocalstorage: function setPlayZoneLocalstorage() {
    var _arguments7 = arguments,
      _this10 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee11() {
      var opts, playZoneId, prefix, _opts$data8, data, gameId, system, userKey, check, key, zoneHistoryStorage, result, playZoneObj;
      return regenerator_default.a.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            opts = _arguments7.length > 0 && _arguments7[0] !== undefined ? _arguments7[0] : {};
            playZoneId = opts.playZoneId;
            prefix = opts.prefix, _opts$data8 = opts.data, data = _opts$data8 === void 0 ? {} : _opts$data8;
            gameId = data.gameId, system = data.system;
            _context11.next = 6;
            return user_default.a.userKey();
          case 6:
            userKey = _context11.sent;
            check = _this10.checkField({
              prefix: prefix,
              gameId: gameId,
              system: system,
              userKey: userKey
            });
            if (check) {
              _context11.next = 10;
              break;
            }
            return _context11.abrupt("return");
          case 10:
            key = "".concat(prefix, "_zone_user_history_").concat(gameId);
            _context11.next = 13;
            return bridge_default.a.getNativeStorage(key);
          case 13:
            zoneHistoryStorage = _context11.sent;
            result = zoneHistoryStorage || {};
            playZoneObj = _objectSpread(defineProperty_default()({}, system, {}), result);
            playZoneObj[system][userKey] = {
              code: 100000,
              data: [{
                main_district_id: playZoneId
              }]
            };
            bridge_default.a.setNativeStorage(key, playZoneObj);
          case 18:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }))();
  }
};
/* harmony default export */ var core_zone = (zone);
// EXTERNAL MODULE: external "@tencent/iwan-atta-fe"
var iwan_atta_fe_ = __webpack_require__(25);

// CONCATENATED MODULE: ./src/core/role/report.js




var cgiRoleReport = /*#__PURE__*/function () {
  var _ref2 = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee(_ref, gameId) {
    var _ref3, err, res, extraJson;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref3 = slicedToArray_default()(_ref, 2), err = _ref3[0], res = _ref3[1];
          extraJson = '';
          try {
            extraJson = JSON.stringify(err || res);
          } catch (e) {}
          Object(iwan_atta_fe_["attaIWAction"])({
            actionType: 'cgi-check-role',
            iwanGameKey: gameId,
            extraJson: extraJson
          });
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function cgiRoleReport(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
/* harmony default export */ var report = (cgiRoleReport);
// CONCATENATED MODULE: ./src/core/role/index.js






function role_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function role_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? role_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : role_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var role_Role = /*#__PURE__*/function () {
  function Role() {
    classCallCheck_default()(this, Role);
    this.cache = {};
    this.success = {
      code: 0,
      list: [],
      msg: ''
    };
    this.error = {
      code: 1,
      list: [],
      msg: ''
    };
  }
  return createClass_default()(Role, [{
    key: "get",
    value: function () {
      var _get = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee(opts) {
        var _opts$data, data, serverId, gameId, roleData, rel, _rel, err, res;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _opts$data = opts.data, data = _opts$data === void 0 ? {} : _opts$data;
              serverId = data.serverId, gameId = data.gameId; // 没有gameId则直接返回 []
              if (gameId) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", this.error);
            case 4:
              roleData = this.getCache({
                gameId: gameId,
                serverId: serverId
              }); // 获取数据
              _context.t0 = roleData;
              if (_context.t0) {
                _context.next = 10;
                break;
              }
              _context.next = 9;
              return Object(txv_utils_["to"])(this.getRole(opts));
            case 9:
              _context.t0 = _context.sent;
            case 10:
              rel = _context.t0;
              // 重要接口-后台获取角色，前端记一层返回日志
              report(rel, gameId);
              _rel = slicedToArray_default()(rel, 2), err = _rel[0], res = _rel[1];
              if (!(err || Number(res.success) !== 1)) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("return", role_objectSpread(role_objectSpread({}, this.error), {}, {
                code: res.code
              }));
            case 15:
              this.setCache({
                gameId: gameId,
                serverId: serverId,
                res: res
              });
              return _context.abrupt("return", role_objectSpread(role_objectSpread({}, this.success), {}, {
                list: this.format(res, serverId)
              }));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function get(_x) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "getCache",
    value: function getCache(_ref) {
      var gameId = _ref.gameId,
        serverId = _ref.serverId;
      if (!this.cache[gameId]) {
        return null;
      }
      if (serverId) {
        return this.cache[gameId][serverId];
      }
      return this.cache[gameId];
    }
  }, {
    key: "setCache",
    value: function setCache(_ref2) {
      var gameId = _ref2.gameId,
        serverId = _ref2.serverId,
        res = _ref2.res;
      if (serverId) {
        this.cache[gameId] = this.cache[gameId] || {};
        this.cache[gameId][serverId] = [null, res];
      } else {
        this.cache[gameId] = [null, res];
      }
    }
  }, {
    key: "getRole",
    value: function getRole(opts) {
      var cgiRole = opts.cgiRole,
        data = opts.data;
      if (Object(txv_utils_["isFunction"])(cgiRole)) {
        return cgiRole.bind(this)({
          params: data
        });
      }
      return api_default.a.get('/interface/checkapprole', {
        params: data
      });
    }
  }, {
    key: "format",
    value: function format(res, serverId) {
      if (Object(txv_utils_["isObject"])(res.error)) {
        var item = res.error;
        return [{
          roleId: item.role_id,
          roleName: Object(helper_["filterXSS"])(item.role_name)
        }];
      }

      // 小游戏中返回的角色列表中，存在zoneId字段直接作为serverId
      if (Object(txv_utils_["isArray"])(res.error)) {
        return res.error.map(function (item) {
          return {
            serverId: item.zoneId || serverId,
            serverName: item.zoneName || '',
            roleId: item.role_id,
            roleName: Object(helper_["filterXSS"])(item.role_name)
          };
        });
      }
      return [];
    }
  }]);
}();
/* harmony default export */ var role = (new role_Role());
// EXTERNAL MODULE: external "@tencent/txv-athena/lib/select"
var select_ = __webpack_require__(46);
var select_default = /*#__PURE__*/__webpack_require__.n(select_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/button"
var button_ = __webpack_require__(15);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/radio-group"
var radio_group_ = __webpack_require__(53);
var radio_group_default = /*#__PURE__*/__webpack_require__.n(radio_group_);

// CONCATENATED MODULE: ./src/comps/business/zone-role-select/report.js

var report_initReport = function initReport(zoneSelect) {
  var gameId = zoneSelect.options.gameId;

  // 区服角色切换上报
  zoneSelect.on('change', function (data) {
    var selectZone = data.selectZone,
      selectRole = data.selectRole,
      selectServer = data.selectServer,
      changeType = data.changeType;

    // changeType = init / change 。初始化角色信息和手动切换信息
    // 两个事件 zone-role-init 和 zone-role-change
    Object(iwan_atta_fe_["attaIWAction"])({
      actionType: "zone-role-".concat(changeType),
      iwanGameKey: gameId,
      extraJson: JSON.stringify({
        zoneId: selectZone.id,
        roleId: selectRole.roleId,
        roleName: selectRole.roleName,
        serverId: selectServer.id
      })
    });
  });

  // 展示弹窗时数据更新上报
  zoneSelect.on('zone-cache-update', function (data) {
    var newMd5 = data.newMd5,
      oldMd5 = data.oldMd5;
    var isActive = newMd5 === oldMd5 ? '1' : '0';
    Object(iwan_atta_fe_["attaIWAction"])({
      actionType: 'zone-cache-update',
      iwanGameKey: gameId,
      extraJson: isActive
    });
  });

  // 获取区服数据来源于当前页面调用接口
  zoneSelect.on('zone-data-from-cgi', function () {
    Object(iwan_atta_fe_["attaIWAction"])({
      actionType: 'zone-data-from-cgi',
      iwanGameKey: gameId
    });
  });

  // 获取区服数据来源于本地存储
  zoneSelect.on('zone-data-from-storage', function () {
    Object(iwan_atta_fe_["attaIWAction"])({
      actionType: 'zone-data-from-storage',
      iwanGameKey: gameId
    });
  });

  // 用户最近选取角色数据来源于本地存储
  zoneSelect.on('user-play-data-from-storage', function (res) {
    Object(iwan_atta_fe_["attaIWAction"])({
      actionType: 'user-play-data-from-storage',
      iwanGameKey: gameId,
      extraJson: JSON.stringify(res.data)
    });
  });

  // 用户最近选取角色数据来源于当前页面接口
  zoneSelect.on('user-play-data-from-cgi', function (res) {
    Object(iwan_atta_fe_["attaIWAction"])({
      actionType: 'user-play-data-from-cgi',
      iwanGameKey: gameId,
      extraJson: JSON.stringify(res.data)
    });
  });
};
/* harmony default export */ var zone_role_select_report = (report_initReport);
// CONCATENATED MODULE: ./src/comps/business/zone-role-select/template.js
/* harmony default export */ var template = ("\n    <div class=\"zone-role-select\">\n        <div class=\"mod-loading-icon\">\n          <i class=\"mod-loading-icon-add\"></i>\n          <i class=\"mod-loading-icon-dot1\"></i>\n          <i class=\"mod-loading-icon-dot2\"></i>\n        </div>\n    </div>\n");
// CONCATENATED MODULE: ./src/comps/business/zone-role-select/index.js









function zone_role_select_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function zone_role_select_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? zone_role_select_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : zone_role_select_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }












var zone_role_select_ZoneRoleSelect = /*#__PURE__*/function (_Component) {
  function ZoneRoleSelect(container, options) {
    var _this;
    classCallCheck_default()(this, ZoneRoleSelect);
    _this = _callSuper(this, ZoneRoleSelect, [container, options]);
    _this.eventHub = txv_utils_["EventHub"].createEvents(_this);
    _this.options = zone_role_select_objectSpread({
      gameId: '',
      prefix: '',
      // 区服存储 localstorage 拼接字
      system: Object(helper_["getPhoneSystem"])(),
      channel: ''
    }, _this.options);

    // gameId为必传参数
    if (!_this.options.gameId) {
      throw new Error('错误：绑定区服角色缺少游戏ID参数');
    }
    _this.zoneList = [];
    _this.roleList = [];
    _this.playServerId = '';
    _this.selectZone = {};
    _this.selectRole = {};
    _this.selectServer = {};
    _this.actionArr = [];
    _this.isLoding = true;
    _this.showRoleSelect = true; // 是否显示角色选择栏
    _this.gameType = ''; // 游戏类型

    _this.useDiySelect = _this.ifDiySelect();

    // 上报事件监听
    zone_role_select_report(_this);

    // 初始化数据，显示区服角色
    _this.initData();

    // 初始化组件就传了container
    if (_this.$container.length) {
      _this.action();
    }
    return _this;
  }
  inherits_default()(ZoneRoleSelect, _Component);
  return createClass_default()(ZoneRoleSelect, [{
    key: "ifDiySelect",
    value: function ifDiySelect() {
      var _urlToJson = Object(txv_utils_["urlToJson"])(),
        screen = _urlToJson.screen;
      return Object(helper_["getOs"])() !== 'ios' && Object(helper_["isTenvideo"])() && screen === 'mini';
    }
  }, {
    key: "render",
    value: function render() {
      return template;
    }

    /**
     * 初始化弹窗数据（区服、角色信息）
     */
  }, {
    key: "initData",
    value: (function () {
      var _initData = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var channel;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              channel = this.options.channel;
              _context.t0 = channel;
              if (_context.t0) {
                _context.next = 6;
                break;
              }
              _context.next = 5;
              return this.getMainLoginType();
            case 5:
              _context.t0 = _context.sent;
            case 6:
              this.options.channel = _context.t0;
              if (this.options.channel) {
                _context.next = 10;
                break;
              }
              console.warn('警告：缺少登录参数 channel');
              return _context.abrupt("return");
            case 10:
              _context.next = 12;
              return Promise.all([this.fetchGameZone(), this.fetchPlayServerId()]);
            case 12:
              // 根据用户玩过的区服，更改默认选择的区服
              this.playServerId && this.initSelectZone();

              // 根据选择的区服获取角色
              _context.next = 15;
              return this.fetchUserRole();
            case 15:
              this.isLoding = false;

              // 发送初始化的区服角色
              this.fireZoneRole('init');

              // 当通过register注册该组件调用action方法时数据还在loading
              this.consumeActions();
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }())
  }, {
    key: "consumeActions",
    value: function consumeActions() {
      var _this2 = this;
      this.actionArr.forEach(function (func) {
        func.apply(_this2);
      });
      this.actionArr = [];
    }

    /**
     * 渲染区服选择栏
     */
  }, {
    key: "action",
    value: function action() {
      if (this.isLoding) {
        this.actionArr.push(this.action);
        return;
      }
      this.$container.find('.zone-role-select > .mod-loading-icon').remove();
      var innerContainer = this.$container.find('.zone-role-select');
      if (this.isRenderHistorySelect()) {
        this.renderHistorySelect(innerContainer);
      } else {
        this.renderSeparateSelect(innerContainer);
      }
    }

    /**
     * 判断是否是端游
     */
  }, {
    key: "isClientGame",
    value: function isClientGame() {
      return this.gameType === variable_["GAME_TYPE"].client;
    }

    /**
     * 判断是否是小游戏场景
     */
  }, {
    key: "isH5Game",
    value: function isH5Game() {
      return [variable_["GAME_TYPE"].h5, variable_["GAME_TYPE"].sdk].includes(this.gameType);
    }

    /**
     * 初始化选择的区服
     * @returns {null|*}
     */
  }, {
    key: "initSelectZone",
    value: function initSelectZone() {
      if (this.isClientGame()) {
        this.initClientGameSelect();
        return;
      }
      this.initGameSelect();
    }

    /**
     * 初始化端游区服信息
     */
  }, {
    key: "initClientGameSelect",
    value: function initClientGameSelect() {
      var _this3 = this;
      for (var i = 0, len = this.zoneList.length; i < len; i++) {
        var item = this.zoneList[i];
        var _item$data = item.data,
          data = _item$data === void 0 ? [] : _item$data;
        var server = data.find(function (server) {
          return server.id === _this3.playServerId;
        });
        if (server) {
          this.selectZone = item;
          this.selectServer = server;
        }
      }
    }

    /**
     * 通过playServerId初始化zone
     */
  }, {
    key: "initGameSelect",
    value: function initGameSelect() {
      var _this4 = this;
      var selectZone = this.zoneList.find(function (item) {
        return item.id === _this4.playServerId;
      });
      if (selectZone) {
        this.selectZone = selectZone;
      }
    }

    /**
     * 判断是否展示历史区服-角色radio-group选择栏
     * 展示条件：用户有玩过的历史区服
     * @returns {string|boolean}
     */
  }, {
    key: "isRenderHistorySelect",
    value: function isRenderHistorySelect() {
      return this.playServerId !== -1 && this.playServerId === this.selectRole.serverId && this.showRoleSelect;
    }

    /**
     * 显示区服角色分开的选择栏
     */
  }, {
    key: "renderSeparateSelect",
    value: function renderSeparateSelect(container) {
      this.renderZoneSelect(container);
      this.renderRoleSelect(container);
    }

    /**
     * 当游戏没有区服，区服列表list返回的只是channel和system信息
     * 区服list: [{ "name": "微信","id": -1,"systemId": "0","system": "ios","channelId": "11","channel": "weixin"}]
     * list.length=1前端不展示区服选择栏（list.length>1，展示区服选择栏让用户选择）
     */
  }, {
    key: "checkZoneList",
    value: function checkZoneList(zoneList) {
      return zoneList.length && !(zoneList.length === 1 && zoneList[0].value === -1);
    }

    /**
     * 校验用户玩过的区服信息数据是否合法
     * @param {*} err
     * @param {*} res
     */
  }, {
    key: "checkUserPlayZone",
    value: function checkUserPlayZone(err, res) {
      return !err && res && variable_["CODES_SUCCESS"].codes.includes(res.code);
    }

    /**
     * 初始化区服选择栏
     * @param container
     */
  }, {
    key: "renderZoneSelect",
    value: function renderZoneSelect(container) {
      var _this5 = this;
      var zoneList = this.formatZoneData(this.zoneList, this.selectZone);
      if (!this.checkZoneList(zoneList)) {
        return;
      }
      var isClientGame = this.isClientGame();
      var zoneSelect = new select_default.a(container, {
        valueList: zoneList,
        useDiySelect: this.useDiySelect
      });
      isClientGame && this.renderServerSelect(container);
      zoneSelect.on('select-change', function (val) {
        _this5.zoneSelectChange(val, container);
      });
    }
  }, {
    key: "zoneSelectChange",
    value: function () {
      var _zoneSelectChange = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2(val, container) {
        var isClientGame, _this$selectZone$data, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isClientGame = this.isClientGame();
              this.selectZone = this.getZoneById(val);
              if (isClientGame) {
                _this$selectZone$data = this.selectZone.data, data = _this$selectZone$data === void 0 ? [] : _this$selectZone$data;
                this.selectServer = data[0] || {};
              }
              _context2.next = 5;
              return this.fetchUserRole();
            case 5:
              if (isClientGame) {
                this.serverSelect.destroy();
                this.renderServerSelect(container);
              }
              this.roleSelect && this.roleSelect.destroy();
              this.renderRoleSelect(container);
              this.fireZoneRole();
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function zoneSelectChange(_x, _x2) {
        return _zoneSelectChange.apply(this, arguments);
      }
      return zoneSelectChange;
    }()
    /**
     * 客户端游戏初始化地区下的服务器列表
     * @param container
     */
  }, {
    key: "renderServerSelect",
    value: function renderServerSelect(container) {
      var _this6 = this;
      var serverList = this.formatZoneData(this.selectZone.data, this.selectServer);

      // 部分端游如DNF，除zoneSelect外还有serverSelect可以选，serverList有长度
      // 部分端游如LOL，serverList为空数组，保留select的联动逻辑，同时避免渲染一个空的选取框，container置空
      var serverSelectContainer = serverList.length === 0 ? '' : container;
      this.serverSelect = new select_default.a(serverSelectContainer, {
        valueList: serverList,
        useDiySelect: this.useDiySelect
      });
      this.serverSelect.on('select-change', function (val) {
        _this6.selectServer = _this6.getServerById(val);
        console.log('selectServer change', val, _this6.selectServer);
        _this6.fetchUserRole().then(function () {
          _this6.roleSelect && _this6.roleSelect.destroy();
          _this6.renderRoleSelect(container);
          _this6.fireZoneRole();
        });
      });
    }
  }, {
    key: "checkRoleTip",
    value: function checkRoleTip(container) {
      var roleTipDom = container === null || container === void 0 ? void 0 : container.find('.create-role-tip');
      if (this.roleList.length) {
        roleTipDom.length && roleTipDom.remove();
      } else {
        var tipDom = '<div class="create-role-tip">请先进入游戏创建游戏角色，才能继续哦！</div>';
        !(roleTipDom !== null && roleTipDom !== void 0 && roleTipDom.length) && (container === null || container === void 0 ? void 0 : container.append(tipDom));
      }
    }
  }, {
    key: "checkLoginTip",
    value: function checkLoginTip(container) {
      var notLoginTipDom = container === null || container === void 0 ? void 0 : container.find('.role-not-login-tip');
      if (this.roleList.length) {
        notLoginTipDom.length && notLoginTipDom.remove();
      } else if (!this.ifLogin) {
        var tipDom = "<div class=\"role-not-login-tip\">".concat(variable_["CODES_ERROR_LOGIN"].message, "</div>");
        !(notLoginTipDom !== null && notLoginTipDom !== void 0 && notLoginTipDom.length) && (container === null || container === void 0 ? void 0 : container.append(tipDom));
      }
    }

    /**
     * 初始化角色选择栏
     * @param container
     */
  }, {
    key: "renderRoleSelect",
    value: function renderRoleSelect(container) {
      var _this7 = this;
      // 若游戏隐藏角色栏，则不渲染角色栏
      if (!this.showRoleSelect) {
        this.checkLoginTip(container);
        this.ifLogin && this.checkRoleTip(container);
        return;
      }
      var roleList = this.formatRoleData(this.roleList, this.selectRole);
      this.roleSelect = new select_default.a(container, {
        className: 'select-role',
        valueList: roleList,
        useDiySelect: this.useDiySelect,
        diySelectNullLabel: '该区服暂无角色'
      });
      this.roleSelect.on('select-change', function (val) {
        _this7.selectRole = _this7.getRoleById(val);
        _this7.fireZoneRole();
      });
      this.checkLoginTip(container);
    }

    /**
     * 显示有玩过的区服角色的选择栏
     */
  }, {
    key: "renderHistorySelect",
    value: function renderHistorySelect(container) {
      var _this8 = this;
      var zoneRoleList = this.formatZoneRoleData({
        roleList: this.roleList,
        selectZone: this.selectZone,
        selectRole: this.selectRole,
        selectServer: this.selectServer
      });
      var radioGroup = new radio_group_default.a(container, {
        className: 'joint-select',
        type: 'column',
        labelList: zoneRoleList,
        prepend: '选择角色'
      });
      radioGroup.on('radio-change', function (val) {
        _this8.selectRole = _this8.getRoleById(val);
        console.log('selectZoneRole change', val, _this8.selectZone, _this8.selectRole);
        _this8.fireZoneRole();
      });
      var $radioPrepend = radioGroup.$renderDom.find('.mod-radio-prepend');
      new button_default.a($radioPrepend, {
        type: 'invisible',
        text: '更改'
      }).on('button-click', function () {
        radioGroup.destroy();
        _this8.renderSeparateSelect(container);
      });
    }

    /**
     * 对于没有返回游戏区服的channel信息，前端获取一次 qq or wx
     * @returns {*}
     */
  }, {
    key: "autoDefaultChannelId",
    value: function autoDefaultChannelId() {
      var channel = this.options.channel;
      return variable_["DEFAULT_CHANNEL_MAP"][channel] || '';
    }

    /**
     * 对于没有返回游戏区服的system信息，前端获取一次 ios or android
     * @returns {*}
     */
  }, {
    key: "autoDefaultSystem",
    value: function autoDefaultSystem() {
      var system = this.options.system;
      return variable_["DEFAULT_SYSTEM_MAP"][system] || '';
    }
  }, {
    key: "handleAmsParams",
    value: function handleAmsParams() {
      var _this$selectZone = this.selectZone,
        _this$selectZone$chan = _this$selectZone.channelId,
        channelId = _this$selectZone$chan === void 0 ? this.autoDefaultChannelId() : _this$selectZone$chan,
        _this$selectZone$syst = _this$selectZone.systemId,
        systemId = _this$selectZone$syst === void 0 ? this.autoDefaultSystem() : _this$selectZone$syst,
        id = _this$selectZone.id;
      var params = {};
      if (this.isClientGame()) {
        var serverId = this.selectServer.id;
        params = {
          serverId: serverId || id,
          sPlat: -1,
          sArea: id
        };
      } else {
        params = {
          serverId: id,
          sArea: channelId,
          sPlat: systemId
        };
      }
      return params;
    }
  }, {
    key: "getMainLoginType",
    value: function () {
      var _getMainLoginType = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var res;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.mainLogin) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", this.mainLogin);
            case 2:
              _context3.next = 4;
              return bridge_default.a.getMainLoginType();
            case 4:
              res = _context3.sent;
              this.mainLogin = res.result;
              return _context3.abrupt("return", res.result);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getMainLoginType() {
        return _getMainLoginType.apply(this, arguments);
      }
      return getMainLoginType;
    }()
  }, {
    key: "getZoneFromCgi",
    value: function () {
      var _getZoneFromCgi = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4(opts) {
        var _yield$zone$getGameZo, _yield$zone$getGameZo2, err, _yield$zone$getGameZo3, res, _res$data, data, _data$md, newMd5, _opts$oldMd, oldMd5;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return core_zone.getGameZone(opts);
            case 2:
              _yield$zone$getGameZo = _context4.sent;
              _yield$zone$getGameZo2 = slicedToArray_default()(_yield$zone$getGameZo, 2);
              err = _yield$zone$getGameZo2[0];
              _yield$zone$getGameZo3 = _yield$zone$getGameZo2[1];
              res = _yield$zone$getGameZo3 === void 0 ? {} : _yield$zone$getGameZo3;
              if (!err) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return", {});
            case 9:
              // 上报更新缓存时，数据的变更情况
              _res$data = res.data, data = _res$data === void 0 ? {} : _res$data;
              _data$md = data.md5, newMd5 = _data$md === void 0 ? '' : _data$md;
              _opts$oldMd = opts.oldMd5, oldMd5 = _opts$oldMd === void 0 ? '' : _opts$oldMd;
              this.eventHub.fire('zone-cache-update', {
                oldMd5: oldMd5,
                newMd5: newMd5
              });
              core_zone.setZoneLocalStorage(zone_role_select_objectSpread(zone_role_select_objectSpread({}, opts), {}, {
                res: res
              }));
              return _context4.abrupt("return", res);
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getZoneFromCgi(_x3) {
        return _getZoneFromCgi.apply(this, arguments);
      }
      return getZoneFromCgi;
    }()
    /**
     * 校验返回结果是否合法
     */
  }, {
    key: "checkFetchRes",
    value: function checkFetchRes(opts) {
      var err = opts.err,
        res = opts.res,
        list = opts.list;
      return !err && res && !res.errno && list.length;
    }
  }, {
    key: "getGameZone",
    value: function () {
      var _getGameZone = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5(opts) {
        var zoneStorage, _zoneStorage, _zoneStorage$data, data, md5;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return core_zone.getZoneLocalStorage(opts);
            case 2:
              zoneStorage = _context5.sent;
              if (zoneStorage) {
                _context5.next = 10;
                break;
              }
              this.eventHub.fire('zone-data-from-cgi');
              _context5.next = 7;
              return this.getZoneFromCgi(opts);
            case 7:
              zoneStorage = _context5.sent;
              _context5.next = 14;
              break;
            case 10:
              this.eventHub.fire('zone-data-from-storage');
              // 从远程拉取数据异步更新缓存
              _zoneStorage = zoneStorage, _zoneStorage$data = _zoneStorage.data, data = _zoneStorage$data === void 0 ? {} : _zoneStorage$data;
              md5 = data.md5;
              this.getZoneFromCgi(zone_role_select_objectSpread(zone_role_select_objectSpread({}, opts), {}, {
                oldMd5: md5
              }));
            case 14:
              return _context5.abrupt("return", zoneStorage);
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getGameZone(_x4) {
        return _getGameZone.apply(this, arguments);
      }
      return getGameZone;
    }()
    /**
     * 获取游戏区服信息
     * @returns []
     */
  }, {
    key: "fetchGameZone",
    value: (function () {
      var _fetchGameZone = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _this$options, prefix, gameId, system, channel, cgiGameZone, opts, _yield$to, _yield$to2, res, _ref, _ref$data, data, gameType, hasRole, _data$list, list, _list, _list$, selectZone, _this$selectZone$data2, _data, _data2, _data2$, selectServer;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this$options = this.options, prefix = _this$options.prefix, gameId = _this$options.gameId, system = _this$options.system, channel = _this$options.channel, cgiGameZone = _this$options.cgiGameZone;
              opts = {
                prefix: prefix,
                data: {
                  gameId: gameId,
                  system: system,
                  channel: channel
                },
                cgiGameZone: cgiGameZone
              };
              _context6.next = 4;
              return Object(txv_utils_["to"])(this.getGameZone(opts));
            case 4:
              _yield$to = _context6.sent;
              _yield$to2 = slicedToArray_default()(_yield$to, 2);
              res = _yield$to2[1];
              _ref = res || {}, _ref$data = _ref.data, data = _ref$data === void 0 ? {} : _ref$data;
              gameType = data.gameType, hasRole = data.hasRole, _data$list = data.list, list = _data$list === void 0 ? [] : _data$list;
              _list = slicedToArray_default()(list, 1), _list$ = _list[0], selectZone = _list$ === void 0 ? {} : _list$;
              this.gameType = "".concat(gameType); // 游戏类型
              this.showRoleSelect = hasRole; // 是否展示角色选择栏

              // 若没有区服数据，尝试返回前端获取值android/ios，qq/wx，id=-1给到接口兜底默认值
              if (this.checkFetchRes({
                res: res,
                list: list
              })) {
                _context6.next = 15;
                break;
              }
              this.selectZone = {
                id: -1,
                channelId: this.autoDefaultChannelId(),
                systemId: this.autoDefaultSystem()
              };
              return _context6.abrupt("return");
            case 15:
              // 初始化默认选择的区服
              this.selectZone = selectZone;
              this.zoneList = list;
              if (this.isClientGame()) {
                _this$selectZone$data2 = this.selectZone.data, _data = _this$selectZone$data2 === void 0 ? [] : _this$selectZone$data2;
                _data2 = slicedToArray_default()(_data, 1), _data2$ = _data2[0], selectServer = _data2$ === void 0 ? {} : _data2$;
                this.selectServer = selectServer;
              }
              return _context6.abrupt("return", list);
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchGameZone() {
        return _fetchGameZone.apply(this, arguments);
      }
      return fetchGameZone;
    }()
    /**
     * 获取用户历史区服id
     * @returns ''
     */
    )
  }, {
    key: "fetchPlayServerId",
    value: (function () {
      var _fetchPlayServerId = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var _this$options2, prefix, gameId, system, cgiUserGameZone, opts, _yield$to3, _yield$to4, err, res, _res$data2, data, _data3, _data3$, playServer, playServerId;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this$options2 = this.options, prefix = _this$options2.prefix, gameId = _this$options2.gameId, system = _this$options2.system, cgiUserGameZone = _this$options2.cgiUserGameZone;
              opts = {
                prefix: prefix,
                data: {
                  gameId: gameId,
                  system: system,
                  sPlat: this.getPlat()
                },
                cgiUserGameZone: cgiUserGameZone
              };
              _context7.next = 4;
              return Object(txv_utils_["to"])(this.getUserPlayZone(opts));
            case 4:
              _yield$to3 = _context7.sent;
              _yield$to4 = slicedToArray_default()(_yield$to3, 2);
              err = _yield$to4[0];
              res = _yield$to4[1];
              if (this.checkUserPlayZone(err, res)) {
                _context7.next = 10;
                break;
              }
              return _context7.abrupt("return");
            case 10:
              _res$data2 = res.data, data = _res$data2 === void 0 ? [] : _res$data2;
              _data3 = slicedToArray_default()(data, 1), _data3$ = _data3[0], playServer = _data3$ === void 0 ? {} : _data3$;
              playServerId = playServer.main_district_id;
              if (playServerId) {
                this.playServerId = playServerId;
                this.setPlayZoneLocalstorage(playServerId);
              }
              return _context7.abrupt("return", this.playServerId);
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function fetchPlayServerId() {
        return _fetchPlayServerId.apply(this, arguments);
      }
      return fetchPlayServerId;
    }()
    /**
     * 获取用户玩过的区服
     * 优先cache，其次远程
     * @param {*} opts
     */
    )
  }, {
    key: "getUserPlayZone",
    value: (function () {
      var _getUserPlayZone = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee8(opts) {
        var userPlayZoneCache, res;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return core_zone.getPlayZoneLocalStorage(opts);
            case 2:
              userPlayZoneCache = _context8.sent;
              if (!userPlayZoneCache) {
                _context8.next = 6;
                break;
              }
              this.eventHub.fire('user-play-data-from-storage', {
                data: userPlayZoneCache
              });
              return _context8.abrupt("return", userPlayZoneCache);
            case 6:
              _context8.next = 8;
              return core_zone.getUserPlayZone(opts);
            case 8:
              res = _context8.sent;
              this.eventHub.fire('user-play-data-from-cgi', {
                data: res
              });
              return _context8.abrupt("return", res);
            case 11:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getUserPlayZone(_x5) {
        return _getUserPlayZone.apply(this, arguments);
      }
      return getUserPlayZone;
    }())
  }, {
    key: "getPlat",
    value: function getPlat() {
      return Object(helper_["getOs"])() === 'ios' ? 2 : 1;
    }
  }, {
    key: "getZoneId",
    value: function getZoneId() {
      return this.isClientGame() ? this.selectServer.id : this.selectZone.id;
    }

    /**
     * 获取游戏角色信息
     * @returns Array [{serverId: "", roleId: "", roleName: ""}]
     */
  }, {
    key: "fetchUserRole",
    value: (function () {
      var _fetchUserRole = asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var _this$options3, gameId, cgiRole, params, _yield$role$get, code, _yield$role$get$list, list, _list2, _list2$, selectRole, zoneId;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this$options3 = this.options, gameId = _this$options3.gameId, cgiRole = _this$options3.cgiRole;
              params = this.handleAmsParams();
              _context9.next = 4;
              return role.get({
                data: zone_role_select_objectSpread({
                  gameId: gameId,
                  plat: this.getPlat()
                }, params),
                cgiRole: cgiRole
              });
            case 4:
              _yield$role$get = _context9.sent;
              code = _yield$role$get.code;
              _yield$role$get$list = _yield$role$get.list;
              list = _yield$role$get$list === void 0 ? [] : _yield$role$get$list;
              this.ifLogin = !variable_["CODES_ERROR_LOGIN"].codes.includes(code);
              _list2 = slicedToArray_default()(list, 1), _list2$ = _list2[0], selectRole = _list2$ === void 0 ? {} : _list2$;
              this.roleList = list;
              this.selectRole = selectRole;

              // 更新用户历史区服缓存
              if (this.roleList.length) {
                zoneId = this.getZoneId();
                this.setPlayZoneLocalstorage(zoneId);
              }
              return _context9.abrupt("return", list);
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function fetchUserRole() {
        return _fetchUserRole.apply(this, arguments);
      }
      return fetchUserRole;
    }()
    /**
     * 更新playZone
     */
    )
  }, {
    key: "setPlayZoneLocalstorage",
    value: function setPlayZoneLocalstorage(playZoneId) {
      var _this$options4 = this.options,
        prefix = _this$options4.prefix,
        gameId = _this$options4.gameId,
        system = _this$options4.system;
      core_zone.setPlayZoneLocalstorage({
        prefix: prefix,
        data: {
          gameId: gameId,
          system: system
        },
        playZoneId: playZoneId
      });
    }
  }, {
    key: "fireZoneRole",
    value: function fireZoneRole() {
      var changeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'change';
      this.eventHub.fire('change', {
        selectZone: this.selectZone,
        selectRole: this.selectRole,
        selectServer: this.selectServer,
        login: this.ifLogin,
        changeType: changeType
      });
    }
  }, {
    key: "isExpire",
    value: function isExpire(time) {
      var age = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000 * 60 * 60 * 24 * 30;
      if (!time) {
        return;
      }
      var now = Date.now();
      return now - time > age;
    }
  }, {
    key: "isHideZone",
    value: function isHideZone(display) {
      return [0, '0'].includes(display);
    }

    /**
     * 整理区服选择框数据
     * @param list
     * @param select
     */
  }, {
    key: "formatZoneData",
    value: function formatZoneData() {
      var _this9 = this;
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var select = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var filterList = list.filter(function (item) {
        return !_this9.isHideZone(item.display);
      }).map(function (item) {
        return {
          key: item.name,
          value: item.id,
          // 区服id
          label: item.name,
          // 区服名称
          selected: item.id === select.id
        };
      });
      return filterList;
    }

    /**
     * 整理角色选择框数据
     * @param list
     * @param select
     */
  }, {
    key: "formatRoleData",
    value: function formatRoleData() {
      var _this10 = this;
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var select = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var roleData = [{
        key: -1,
        value: -1,
        label: '该区服暂无角色'
      }];
      if (list.length) {
        roleData = list.map(function (item) {
          var label = item.roleName;
          if (_this10.isH5Game() && item.serverName) {
            label += " - ".concat(item.serverName);
          }
          return {
            label: label,
            key: item.roleId,
            value: item.roleId,
            selected: item.roleId === select.roleId
          };
        });
      }
      return roleData;
    }

    /**
     * 用户有玩过的区服时，整理显示玩过的区服角色数据
     * @param roleList 角色列表
     * @param selectZone 选择的区服
     * @param selectRole 选择的角色
     * @param selectServer 客户端游戏地区下的服务
     */
  }, {
    key: "formatZoneRoleData",
    value: function formatZoneRoleData(opts) {
      var _opts$roleList = opts.roleList,
        roleList = _opts$roleList === void 0 ? [] : _opts$roleList,
        _opts$selectZone = opts.selectZone,
        selectZone = _opts$selectZone === void 0 ? {} : _opts$selectZone,
        _opts$selectRole = opts.selectRole,
        selectRole = _opts$selectRole === void 0 ? {} : _opts$selectRole,
        _opts$selectServer = opts.selectServer,
        selectServer = _opts$selectServer === void 0 ? {} : _opts$selectServer;
      var serverName = selectServer.name;
      var _selectZone$name = selectZone.name,
        zoneName = _selectZone$name === void 0 ? '' : _selectZone$name;

      // 客户端游戏区分地区服务器情况
      if (serverName) {
        zoneName = "".concat(zoneName, "-").concat(serverName);
      }
      var data = roleList.map(function (item) {
        var key = item.roleId;
        var label = "".concat(zoneName, "-").concat(item.roleName);
        var selected = item.roleId === selectRole.roleId;
        return {
          key: key,
          label: label,
          selected: selected
        };
      });
      return data;
    }
  }, {
    key: "getZoneById",
    value: function getZoneById(id) {
      var server = this.zoneList.find(function (item) {
        return item.id === id;
      });
      return server || {};
    }

    // 客户端游戏相应地区下获取相应服务器
  }, {
    key: "getServerById",
    value: function getServerById(id) {
      var _this$selectZone$data3 = this.selectZone.data,
        data = _this$selectZone$data3 === void 0 ? [] : _this$selectZone$data3;
      var server = data.find(function (item) {
        return item.id === id;
      });
      return server || {};
    }
  }, {
    key: "getRoleById",
    value: function getRoleById(id) {
      var role = this.roleList.find(function (item) {
        return item.roleId === id;
      });
      return role || {};
    }
  }]);
}(component_default.a);


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ })

/******/ })["default"];